import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MppToggleButtonComponent } from './toggle-button.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [MppToggleButtonComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [MppToggleButtonComponent],
})
export class MppToggleButtonModule {}
